// removed by extract-text-webpack-plugin
module.exports = {"overlaySpinner":"TradeProcurementCta__overlaySpinner__b93a184f","button":"TradeProcurementCta__button__b93a184f","info":"TradeProcurementCta__info__b93a184f","infoLink":"TradeProcurementCta__infoLink__b93a184f","requestSent":"TradeProcurementCta__requestSent__b93a184f","assuranceIcon":"TradeProcurementCta__assuranceIcon__b93a184f","tooltip":"TradeProcurementCta__tooltip__b93a184f","barHeaderWrapper":"TradeProcurementCta__barHeaderWrapper__b93a184f","tooltipContent":"TradeProcurementCta__tooltipContent__b93a184f"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/global/components/TradeProcurement/TradeProcurementCta.scss
// module id = 1373
// module chunks = 7 9